module.exports = __webpack_public_path__ + "static/media/password.ff9f3346.svg";